import React from 'react';
import Grid from "@mui/material/Grid2";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {CircularProgress} from "@mui/material";
import {setStore} from "trim-redux";

function AppLoader({ classes }) {
    const params = new URLSearchParams(window.location.search);
    const appToken = params.get('app_token');
    if(!!appToken){
        setStore({
            isApp:true
        })
    }else{
        setStore({
            isApp:false
        })
    }
    return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            className={classes.appLoader}
        >
            <Grid item xs={12}>
                {
                    !appToken ?
                        <div className="main-loader"></div>
                        :
                        <CircularProgress style={{color:"#F0051F"}}/>
                }
            </Grid>
        </Grid>
    );
}

export default withStyles(Styles)(AppLoader);
